// extracted by mini-css-extract-plugin
module.exports = {"container":"common_container__8Q7vr","h1":"common_h1__3fQiS","label":"common_label__CUI9P"};